import React, { ReactNode } from "react";
import {
  SxProps,
  WhmBox,
  WhmStack,
  whmTheme,
  WhmTypography,
} from "@securitize/reactjs-whm";

interface FlaggedFieldCalloutProps {
  comment?: string;
}

/** Boxed callout shown under a flagged field, matching the Figma spec (node 1293:96725). */
export function FlaggedFieldCallout({ comment }: FlaggedFieldCalloutProps) {
  if (!comment) {
    return null;
  }

  return (
    <WhmBox
      sx={{
        backgroundColor: "rgba(211, 47, 47, 0.06)",
        borderRadius: "8px",
        padding: "12px",
        marginTop: "8px",
      }}
    >
      <WhmTypography
        variant="body2"
        sx={{ color: whmTheme.palette.text.primary }}
      >
        {comment}
      </WhmTypography>
    </WhmBox>
  );
}

interface FlaggedFieldContainerProps {
  sx?: SxProps;
  comment?: string;
  children: ReactNode;
}

/**
 * Wraps a field (or a field + its tooltip icon) so its flagged-comment
 * callout renders directly beneath it without affecting sibling fields in
 * the same row. `sx` should be the sizing the field itself used to carry
 * (e.g. `textFieldStyle`) so the row layout is unchanged.
 */
export function FlaggedFieldContainer({
  sx,
  comment,
  children,
}: FlaggedFieldContainerProps) {
  return (
    <WhmStack sx={sx}>
      {children}
      <FlaggedFieldCallout comment={comment} />
    </WhmStack>
  );
}
